const initialState = {
    draftData: [],
    singleDraftData: {},
    draftLoading: false,
    draftLastDocument: null,
    hasMoreDraftDocuments: true,
};

export default function draftDataReducer(
    state = initialState,
    { type, payload }
) {
    switch (type) {
        case "DRAFT_DATA":
            return {
                ...state,
                draftData: [...state.draftData, ...payload.data],
                draftLastDocument: payload.lastDocument,
                hasMoreDraftDocuments: payload.hasMoreDocument,
            };
        case "IS_DRAFT_EMPTY":
            return {
                ...state,
                draftData: payload.data,
                draftLastDocument: payload.lastDocument,
                hasMoreDraftDocuments: payload.hasMoreDocument,
            };
        case " DRAFT_LOADER":
            return {
                ...state,
                draftLoading: payload,
            };
        case "SINGLE_DRAFT_MOMENTO":
            return {
                ...state,
                singleDraftData: payload,
            };
        default:
            return { ...state };
    }
}
